export default __webpack_public_path__ + "static/media/favorite_check_white.760fa35f.svg";